import { createStore } from 'redux'
import { InitialState } from '../data/initialState'
import Constants from '../data/constants'

const statusHandler = function(state = InitialState(), action) {
    let _newState = Object.assign({}, state);
    let nextStep;

    switch (action.type) {
        case Constants().NEXT_STEP:
            if (action.success) {
                let nextSection = {
                    formsSection: "carSection",
                    carSection: "timeSection",
                    timeSection: "confirmationSection",
                    driverlicenseSection: "confirmationSection"
                }

                if (typeof window.tesla !== "undefined") {
                    if (window.tesla.App.show_extra_page) {
                        nextSection.timeSection = "driverlicenseSection";
                    }
                }

                nextStep = nextSection[action.currSection];
                if (window.location.search.includes('model=') && action.currSection == "formsSection") {
                    nextStep = "timeSection";
                }
            }
            else {
                nextStep = "confirmationSection";
                action.values.duration = null;
            }

            _newState[action.currSection].containerClass = "";
            _newState[nextStep].containerClass = "show";
            _newState.timeSection.data = action.responseData;
            _newState.timeSection.model = action.model;
            _newState.confirmationSection.values = action.values;

            return _newState;

        case Constants().FINDUS_NEXT_STEP:
            if (action.initializeTimeSection) {
                _newState.timeSection.data = action.responseData;
                _newState.timeSection.model = action.model;
                _newState.confirmationSection.values = action.values;

                return _newState;
            }

            if (action.success) {
                let nextSection = {
                    formsSection: "confirmationSection",
                    carSection: "timeSection",
                    timeSection: "formsSection"
                }

                nextStep = nextSection[action.currSection];
            }
            else {
                nextStep = "confirmationSection";
                action.values.duration = null;
            }

            _newState[action.currSection].containerClass = "";
            _newState[nextStep].containerClass = "show";

            return _newState;

        case Constants().VALIDATE_FORM:
            let { invalid } = action;

            for (let k in invalid) {
                _newState.formsSection.validation[k] = invalid[k];
            }

            return _newState;

    case Constants().ENABLE_ACCEPT_TERMS:
            const { buttonStatus } = action;

            _newState.driverlicenseSection.buttonStatus = buttonStatus;

        return _newState;

        default:
            // _newState = $.extend({}, state, {});
            return state
    }
}

let store = createStore(statusHandler);

export default function StoreHandler() {
    return store;
}
